import React, { FC } from 'react'

import { Link } from '@Components/Link'
import { ProductTileProps } from '@Components/Product/Tile'
import { NavigationEvent } from '@Events/Navigation'

interface Props extends Pick<ProductTileProps, 'id' | 'sourceID' | 'title' | 'url'> {

  personalization: boolean
}

const TileWrapper: FC<Props> = ({
  children,
  id,
  personalization,
  sourceID,
  title,
  url,

}) => {
  if (personalization) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }
  return (
    <Link
      event={
        new NavigationEvent({
          attributes: {
            dest_page_type: 'product',
            dest_page_type_id: id,
            source_id: sourceID || '',
          },
          eventName: 'nav_link_click',
        })
      }
      href={url}
      title={title}
    >
      {children}
    </Link>
  )
}

export default TileWrapper
